<template>
  <div class="zv-page">
    <div class="zv-content">
        <div class="zv-block">
          <div class="zv-breadcrumb-wrap">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/data-analysis/modelList' }">模型管理</el-breadcrumb-item>
              <el-breadcrumb-item>{{ isEdit ? '编辑模型' : '新建模型' }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <el-form ref="myForm" :model="formData" :rules="formRules" :label-width="formLabelWidth">
            <el-form-item label="模型名称:" prop="pattern_name">
              <el-input class="el-input-width-1205" v-model="formData.pattern_name"></el-input>
            </el-form-item>
            <el-form-item label="模型区域类型:" prop="pattern_area_type">
              <el-select
                placeholder="请选择"
                v-model="formData.pattern_area_type"
                filterable
              >
                <el-option
                  v-for="item in $enums.AreaType.forModelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模型类型:" prop="target_type">
              <el-select
                placeholder="请选择"
                v-model="formData.target_type"
                filterable
              >
                <el-option
                  v-for="item in $enums.ModelTargetType.list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <div class="zv-flex-wrap">
              <div class="zv-form-item-label">进事件规则:</div>
              <div class="zv-form-item-content" style="display: block;">
                <div
                  style="width: 100%; flex: 1;"
                  v-for="item in formData.patter_reduce_arr"
                  :key="item.label"
                >
                  <div class="zv-form-item-content">
                    <el-form-item label-width="auto">
                      <el-checkbox :label="item.label + '事件'" v-model="item.checked"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="衰减" label-width="70px">
                      <el-input
                        type="number"
                        v-model.number="item.value"
                        :disabled="!item.checked"
                        placeholder="0~1"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div style="color: #bbb; font-size: 12px;">*衰减值取0~1之间，支持两位小数；衰减0.1则得分会乘以90%</div>
              </div>
            </div>
            <div class="zv-flex-wrap" style="padding-top: 30px;">
              <div class="zv-form-item-label">风险模块:</div>
              <div class="zv-form-item-content" style="display: block; max-width: 1205px;">
                <div style="padding-bottom: 10px;">
                  <el-button type="primary" size="mini" @click="goCreateModelItemPage">添加风险模块</el-button>
                </div>
                <zv-table :table="table" ref="dataTable">
                </zv-table>
              </div>
            </div>
            <el-form-item label="模型总体计算规则:" class="paddint-t-20">
              <el-switch
                :value="modelCalRule"
                active-text="比较规则"
                inactive-text="单模块规则"
              >
              </el-switch>
            </el-form-item>
            <el-form-item label-width="auto" class="fi-flex-center paddint-t-30">
              <el-button @click="goBack">返回</el-button>
              <el-button type="primary" @click="doSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
</template>

<script>
import api from './api';
import formPageMixin from "@/mixins/formPageMixin";
import addFormMixin from "@/mixins/addFormMixin";
import TipUtil from "@/utils/utils/TipUtil";
import EventBus from "@/utils/services/event_service";

export default {
  name: "CreateModel",
  mixins: [formPageMixin, addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      id: '',   // 事件编辑时id
      isEdit: false,   // 是否为编辑
      formData: {
        pattern_name: '',  // 模型名字
        pattern_area_type: '',  // 针对类型 1通用 2华人
        target_type: '',  // 模型可适用范围 2 国 3省 4市
        patter_reduce_arr: [],  //
        // 模型计算事件影响范围 0 全球性 1 洲 2 国 3省（州） 4市 设置多个用,隔开
        pattern_calc_event_affect_area_type: '',
        // 模型计算事件影响范围 结果衰减值（打折） 取值范围0~1 设置多个用,隔开
        pattern_calc_event_affect_area_reduce: '',
        pattern_item_id: '',  // 模型包含的模块id 设置多个用,隔开
      },
      formRules: {
        pattern_name: {
          required: true,
          message: "模型名称不能为空",
          trigger: "blur"
        },
        pattern_area_type: {
          required: true,
          message: "模型区域类型不能为空",
          trigger: "change"
        },
        target_type: {
          required: true,
          message: "模型类型不能为空",
          trigger: "change"
        }
      },
      table: {
        api: api.modelItemList,
        query: {},
        searchData: [
        ],
        autoHeight: true,
        autoLoading: false,
        hidePagination: true,
        columns: [
          {
            title: "风险模块名称",
            key: "pattern_item_name",
            minWidth: "160"
          },
          {
            title: "模块风险类型",
            key: "risk_name"
          },
          {
            title: "模块编号",
            key: "pattern_formula_var",
            render(h, ctx) {
              return h("span", `M${ctx.row.id}`);
            }
          },
          {
            title: "模块权重编号",
            key: "pattern_power_formula_var",
            render(h, ctx) {
              return h("span", `Pm${ctx.row.id}`);
            }
          },
          {
            title: "操作",
            fixed: "right",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.goCreateModelItemPage.bind(this, ctx.row.id)
                  }
                },
                "编辑"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];
              arr.push(editBtn);
              arr.push(delBtn);
              return h("span", arr);
            }
          }
        ]
      },
      deleteApi: api.deleteModelItem,
      deleteSuccessMsg: "删除模块成功"
    };
  },
  computed: {
    modelCalRule() {
      if (this.table && this.table.data && this.table.data.length > 1) {
        return true
      }

      return false
    }
  },

  methods: {
    initCommonData() {
    },

    initAddData() {
      let tempArr = []
      this.$enums.AreaType.forEventList.forEach(item => {
        let tempObj = {
          checked: false,
          label: item.label,
          value: '',
          id: item.value
        }
        tempArr.push(tempObj)
      })
      this.$set(this.formData, 'patter_reduce_arr', tempArr)
    },

    async initEditData() {
      let resData = await api.modelDetail({
        id: this.id
      })
      console.log(resData)
      this.processEditData(resData.info)
    },

    setModelItemList() {
      this.$refs.dataTable.setTableData(this.modelItemList)
    },

    processEditData(resData) {
      let that = this
      let processObj  = Object.assign({}, this.formData, resData)

      let tempArr = []
      this.$enums.AreaType.forEventList.forEach(item => {
        let findIndex = processObj.pattern_calc_event_affect_area_type.findIndex(subItem => subItem == item.value)
        let isSelected = findIndex > -1
        let tempObj = {
          checked: isSelected,
          label: item.label,
          value: isSelected ? processObj.pattern_calc_event_affect_area_reduce[findIndex] : '',
          id: item.value
        }
        tempArr.push(tempObj)
      })

      processObj.patter_reduce_arr = tempArr

      processObj.pattern_calc_event_affect_area_type = processObj.pattern_calc_event_affect_area_type.join(',')
      processObj.pattern_calc_event_affect_area_reduce = processObj.pattern_calc_event_affect_area_reduce.join(',')
      this.formData = processObj
      this.modelItemList = processObj.pattern_item
      this.setModelItemList()
    },

    doSubmit() {
      this.$refs.myForm.validate(async valid => {
        if (!valid) {
          TipUtil.message('请检查表单!', 'warning')
          return
        }
        let apiFunc = this.isEdit ? api.editModel : api.addModel
        let processObj = this.processSubmitData()
        console.log(processObj)
        let res = await apiFunc(processObj)
        console.log(res)
        let msg = this.isEdit ? '修改模型成功' : '新增模型成功'
        TipUtil.message(msg, "success")
        setTimeout(() => {
          this.$router.push('/data-analysis/modelList')
        }, 200)
      })
    },

    processSubmitData() {
      let processObj = this.$_.cloneDeep(this.formData)
      let areaTypeArr = []
      let areaTypeValueArr = []
      processObj.patter_reduce_arr.forEach(item => {
        if (item.checked) {
          areaTypeArr.push(item.id)
          areaTypeValueArr.push(item.value)
        }
      })
      processObj.pattern_calc_event_affect_area_type = areaTypeArr.join(',')
      processObj.pattern_calc_event_affect_area_reduce = areaTypeValueArr.join(',')

      let itemIds = this.table.data.map(item => item.id)
      processObj.pattern_item_id = itemIds.join(',')
      delete processObj.patter_reduce_arr
      delete processObj.pattern_item
      return processObj
    },

    // 跳转到模块新增页面
    goCreateModelItemPage(id) {
      if (!this.canGoModelItemPage()) return false
      let url = `/data-analysis/createModelItem?targetType=${ this.formData.target_type }`
      if (typeof id == 'string' || typeof id == 'number') {
        url += `&id=${ id }`
      }
      this.$router.push(url)
    },

    canGoModelItemPage() {
      if (this.formData.target_type == '') {
        TipUtil.message('请先选择模型类型')
        return false
      }
      return true
    },

    updateModelItemData(itemData) {
      let findIndex = this.table.data.findIndex(item => item.id == itemData.id)
      if (findIndex > -1) {
        this.$set(this.table.data, findIndex, itemData)
      } else {
        this.table.data.push(itemData)
      }
    },

    afterDoDelete(id) {
      let findIndex = this.table.data.findIndex(item => item.id == id)
      this.table.data.splice(findIndex, 1)
    }
  },
  created() {
    let id = this.$route.query.id
    if (id) {
      this.id = id
      this.isEdit = true
    }
    this.initCommonData();
    if (this.isEdit) {
      this.initEditData();
    } else {
      this.initAddData();
    }
  },
  mounted() {
    let vm = this
    EventBus.$off('updateModelItemData').$on('updateModelItemData', function(itemData) {
      vm.updateModelItemData(itemData);
    })
  },
  beforeDestroy() {
    EventBus.$off('updateModelItemData')
  }
};
</script>

<style lang="less" scoped>

</style>
